export default {
    LOKI: {
        DISABLE_GLOBAL_LOADING: 'disableGlobalLoading',
        ENABLE_GLOBAL_LOADING: 'enableGlobalLoading',
        SET_GLOBAL_LOADING: 'setGlobalLoading',
        SET_LOADING_MESSAGE: 'setLoadingMessage',
        SET_NOTIFICATION: 'setNotification',
        SET_TIMEZONE: 'setTimezone',
        SHOW_ALERT: 'showAlert'
    },
    SET_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA: 'setResumoDaCompraDiretaNaProposta',
    SET_COMPRA_DIRETA: 'setCompraDireta',
    SET_ITENS_E_LOTES: 'setItensELotes',
    SET_DOCUMENTOS_SOLICITADOS: 'setDocumentosSolicitados',
    SET_DOCUMENTOS_PROPOSTA: 'setDocumentosProposta',
    SET_LINHAS_DE_FORNECIMENTO_DA_COMPRA_DIRETA: 'setLinhasDeFornecimentoDaCompraDireta',
    SET_USUARIO_LOGADO: 'setUsuarioLogado',
    SET_PRODUTO: 'setProduto',
}
